import { MachinesView } from "@/admin/metal/machine/MachinesView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/metal/machines/")({
    component: MachinesView,
});
